import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=1fcda059&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrimaryButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=1fcda059&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcda059",
  null
  
)

export default component.exports